/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import confirmAddressBanner from "../../assets/images/confirm-address.png";
import addAddressBanner from "../../assets/images/add-address.png";
import CustomPopup from "../../components/popup/CustomPopup";
import { useLiff } from 'react-liff';
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchDdlAddress } from "../../services/Dropdown";
import { UpdateMember } from "../../services/Shop";
import globalStyle from "../../assets/styles/constants";
import { SearchMemberProfile } from "../../services/Member";
import { UpdatePrize } from "../../services/Prize";
import { setMember } from "../../features/MemberSlice";

export default function PrizeAddress() {

    const txt = {
        require: "กรุณากรอก",
        province: "จังหวัด",
        amphoe: "เขต/อำเภอ",
        tambol: "แขวง/ตำบล",
        zipCode: "รหัสไปรษณีย์",
    };

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    const store = useSelector((state) => state.member)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
    const [openEditedPopup, setOpenEditedPopup] = React.useState(false);
    const [openConfirmPopup, setOpenConfirmPopup] = React.useState(false);

    const [addressList, setAddressList] = React.useState([]);
    const [delayId, setDelayId] = React.useState(null);
    const [subDistrict, setSubDistrict] = React.useState(null);
    const [amphoe, setAmphoe] = React.useState(null);
    const [province, setProvince] = React.useState(null);
    const [zipCode, setZipCode] = React.useState(null);

    const [deSubDistrict, setDeSubDistrict] = React.useState(null);
    const [deAmphoe, setDeAmphoe] = React.useState(null);
    const [deProvince, setDeProvince] = React.useState(null);
    const [deZipCode, setDeZipCode] = React.useState(null);

    const [openDeSubDistrict, setOpenDeSubDistrict] = React.useState(false);
    const [openDeAmphoe, setOpenDeAmphoe] = React.useState(false);
    const [openDeProvince, setOpenDeProvince] = React.useState(false);
    const [openDeZipCode, setOpenDeZipCode] = React.useState(false);

    const [address, setAddress] = React.useState(false);
    const [isAddressCorrect, setIsAddressCorrect] = React.useState(false);
    const [isDetails, setIsDetails] = React.useState(false);



    const { register, formState: { errors }, handleSubmit, getValues, setValue, control, watch } = useForm({
        defaultValues: {
            deAddressDetails: '',
            deSubDistrict: null,
            deAmphoe: null,
            deProvince: null,
            deZipCode: null,
            deSubDistrictId: null,
            deAmphoeId: null,
            deProvinceId: null,
        }
    });

    React.useEffect(() => {
        getSearchMemberProfile()
    }, []);

    async function getSearchMemberProfile() {
        return await SearchMemberProfile({ lineId })
            .then(async (response) => {
                if (+response.data.resultCode !== 20000) {
                    navigate("/register");
                } else {
                    if (response.data.body.deAddressDetails || response.data.body.deAmphoeName) {
                        setValue('deAddressDetails', response.data.body.deAddressDetails)
                        setValue('deSubDistrict', response.data.body.deDistrictName)
                        setValue('deAmphoe', response.data.body.deAmphoeName)
                        setValue('deProvince', response.data.body.deProvinceName)
                        setValue('deZipCode', response.data.body.deZipCode)
                        setAddress(true)
                        getSearchDefaultAddress();
                        if (response.data.body.deAddressDetails) {
                            setIsDetails(true)
                        }
                        if (response.data.body.deAmphoeName) {
                            setIsAddressCorrect(true)
                        }

                    }

                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    React.useEffect(() => {

    }, []);

    async function getSearchDefaultAddress() {
        try {
            if (getValues('deAmphoe')) {
                const search = `${getValues('deSubDistrict')} ${getValues('deAmphoe')} ${getValues('deProvince')} ${getValues('deZipCode')}`
                const { data } = await SearchDdlAddress({ params: { search } });
                if (+data["resultCode"] === 20000) {
                    const body = data.body || [];
                    setDeSubDistrict(body[0]);
                    setValue("deSubDistrict", body[0].subDistrict);
                    setValue("deSubDistrictId", body[0].subDistrictId);
                    setDeAmphoe(body[0]);
                    setValue("deAmphoe", body[0].amphoe);
                    setValue("deAmphoeId", body[0].amphoeId);
                    setDeProvince(body[0]);
                    setValue("deProvince", body[0].province);
                    setValue("deProvinceId", body[0].provinceId);
                    setDeZipCode(body[0]);
                    setValue("deZipCode", body[0].zipcode);
                } else {
                    setAddressList([]);
                }
            }
        } catch (error) {
            console.log("getSearchDdlAddress error", error);
        }
    }

    async function getSearchDdlAddress(search) {
        try {
            const { data } = await SearchDdlAddress({ params: { search } });
            if (+data["resultCode"] === 20000) {
                const body = data.body || [];
                setAddressList(body);
            } else {
                setAddressList([]);
            }
        } catch (error) {
            console.log("getSearchDdlAddress error", error);
        }
    }

    function fnRenderOption(props, option, { inputValue }) {
        const address1 = `${option.subDistrict}, ${option.amphoe}, ${option.zipcode}`;
        const address2 = `จังหวัด ${option.province}`;

        const matches1 = match(address1, inputValue, { insideWords: true });
        const parts1 = parse(address1, matches1);

        const matches2 = match(address2, inputValue, { insideWords: true });
        const parts2 = parse(address2, matches2);

        return (
            <li {...props} className="text-left pl-1 border-address-list">
                {/*display address*/}
                <div>
                    {parts1.map((part, index) => (
                        <span
                            key={index}
                            style={{
                                fontWeight: part.highlight ? 700 : 400,
                                color: part.highlight ? "#0A4197" : "#8F8F8F",
                            }}
                        >
                            {part.text}
                        </span>
                    ))}
                </div>
                {/*display province*/}
                <div>
                    {parts2.map((part, index) => (
                        <span
                            key={index}
                            style={{
                                fontWeight: part.highlight ? 700 : 400,
                                color: part.highlight ? "#0A4197" : "#8F8F8F",
                            }}
                        >
                            {part.text}
                        </span>
                    ))}
                </div>
            </li>
        );
    }


    function fnOnChangeDeAddress(e, value) {
        setIsAddressCorrect(true)
        fnSetOpenDeAddress(txt.tambol, false);
        fnSetOpenDeAddress(txt.amphoe, false);
        fnSetOpenDeAddress(txt.province, false);
        fnSetOpenDeAddress(txt.zipCode, false);
        setDeSubDistrict(value);
        setValue("deSubDistrictId", value.subDistrictId);
        fnSetData("deSubDistrictId", value.subDistrictId);
        setDeAmphoe(value);
        setValue("deAmphoeId", value.amphoeId);
        fnSetData("deAmphoeId", value.amphoeId);
        setDeProvince(value);
        setValue("deProvinceId", value.provinceId);
        fnSetData("deProvinceId", value.provinceId);
        setDeZipCode(value);
        setValue("deZipCode", value.zipcode);
        fnSetData("deZipCode", value.zipcode);
    }

    async function onInputChangeDeAddress(e, type) {
        fnSetOpenDeAddress(type, false);
        const value = e.target.value;

        clearTimeout(delayId);
        const timeoutId = setTimeout(async () => {
            if (value) {
                await getSearchDdlAddress(value);
                fnSetOpenDeAddress(type, true);
            } else {
                if (type === txt.tambol) {
                    setValue("deSubDistrictId", null);
                } else if (type === txt.amphoe) {
                    setValue("deAmphoeId", null);
                } else if (type === txt.province) {
                    setValue("deProvinceId", null);
                } else if (type === txt.zipCode) {
                    setValue("deZipCode", null);
                }
                setIsAddressCorrect(false)
            }
        }, 500);
        setDelayId(timeoutId);
    }

    function fnSetOpenDeAddress(type, open) {
        if (type === txt.tambol) {
            setOpenDeSubDistrict(open);
        } else if (type === txt.amphoe) {
            setOpenDeAmphoe(open);
        } else if (type === txt.province) {
            setOpenDeProvince(open);
        } else if (type === txt.zipCode) {
            setOpenDeZipCode(open);
        }
    }

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setMember(tmpObj));
    }

    React.useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name && type) {
                fnSetData(name, value[name]);
            }
            if (!value.deAddressDetails) {
                setIsDetails(false)
            } else {
                setIsDetails(true)
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);


    const onSubmit = (data) => {
        setOpenEditedPopup(true);
    };

    const onError = (data) => {
    };

    async function postUpdateMember() {
        try {
            let payload = {
                lineId: lineId,
                address: {
                    id: store['memberId'],
                    deAddressDetails: getValues('deAddressDetails'),
                    deAmphoe: deAmphoe.amphoeId,
                    deDistrict: deSubDistrict.subDistrictId,
                    deProvince: deProvince.provinceId,
                    deZipCode: getValues('deZipCode'),
                    fullDeAddress: deAmphoe ? `${getValues('deAddressDetails')} ${deAmphoe ? deAmphoe.amphoe : ''} ${deSubDistrict ? deSubDistrict.subDistrict : ''} ${deProvince ? deProvince.province : ''} ${getValues('deZipCode')}` : getValues('deAddressDetails'),
                }
            }
            Object.keys(payload).forEach(key => {
                if (payload[key] === null) {
                    delete payload[key];
                }
            });
            const { data } = await UpdateMember({ data: payload });
            if (+data["resultCode"] === 20000) {
                setOpenEditedPopup(true)

            } else {
                console.log('Error' + data["resultCode"])
            }
        } catch (error) {
            console.log("postCreateMember error", error);
        }
    }

    async function postUpdatePrize() {
        let fullDeAddress = deAmphoe ? `${getValues('deAddressDetails')} ${deAmphoe ? deAmphoe.amphoe : ''} ${deSubDistrict ? deSubDistrict.subDistrict : ''} ${deProvince ? deProvince.province : ''} ${getValues('deZipCode')}` : getValues('deAddressDetails')
        return await UpdatePrize({ data: { memberId: store['memberId'], prizeId: state.id, deAddress: fullDeAddress } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body
                    navigate("/prize-success", { state: data })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)} noValidate autoComplete="off">
                <CustomPopup
                    title={"ยืนยันที่อยู่"}
                    desc={"ของรางวัลพิเศษจะจัดส่งให้คุณตามที่อยู่ดังกล่าว\nคุณได้ตรวจสอบข้อมูลเรียบร้อยแล้ว"}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        postUpdatePrize()
                        setOpenConfirmPopup(false);
                    }}
                    open={openConfirmPopup}
                />

                <CustomPopup
                    title={"บันทึกที่อยู่เรียบร้อย"}
                    desc={"ข้อมูลที่อยู่ของคุณได้รับการบันทึกแล้ว\nของรางวัลพิเศษจะจัดส่งให้คุณตามที่อยู่ดังกล่าว"}
                    cancelText={"ปิด"}
                    cancelFunction={() => {
                        postUpdatePrize()
                        setOpenEditedPopup(false);
                    }}
                    open={openEditedPopup}

                />

                <CustomPopup
                    title={"ยกเลิกการเพิ่มที่อยู่"}
                    desc={
                        "หากคุณยังไม่ได้เพิ่มที่อยู่ คุณจะไม่สามารถรับ\nของรางวัลพิเศษได้ ต้องการยกเลิกหรือไม่?"
                    }
                    cancelFunction={() => {
                        setOpenCancelPopup(false);
                    }}
                    cancelText={"ยกเลิก"}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        setOpenCancelPopup(false);
                        navigate(-1);
                    }}
                    open={openCancelPopup}
                />
                <TopLogo />
                <TopBanner type="memberPrivilage" />
                <Container maxWidth="xl">
                    {address ? (
                        <img src={confirmAddressBanner} alt="logo" style={{ width: "100%", marginTop: "-50px" }} />
                    ) : (
                        <img src={addAddressBanner} alt="logo" style={{ width: "100%", marginTop: "-50px" }} />
                    )}

                    <div className="bg-white px-3">
                        <div style={{ padding: "0 10px" }}>
                            <div className="flex gap-[10px] justify-start">
                                <div className="primary-color title-size">ที่อยู่ </div>
                                <div style={{ marginTop: "6px" }}>
                                    <p className="sub-title-size">Address</p>
                                    <div className="blue-line" ></div>
                                </div>
                            </div>

                            <div className="mb-[10px]">
                                <div className="">
                                    <InputLabel className="text-header1 text-left" htmlFor="txtAddress">ที่อยู่</InputLabel>
                                    <TextField
                                        id="txtAddress"
                                        fullWidth
                                        placeholder="ที่อยู่ของคุณ"
                                        {...register("deAddressDetails")}
                                    />
                                </div>
                                <div className="grid grid-cols-2 gap-2 mt-3">
                                    <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlSubDistrict">แขวง / ตำบล</InputLabel>
                                    <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlDistrict">เขต / อำเภอ</InputLabel>
                                </div>
                                <div className="grid grid-cols-2 gap-5">
                                    <Controller
                                        name="deSubDistrictId"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                freeSolo
                                                disableClearable
                                                onChange={fnOnChangeDeAddress}
                                                options={addressList}
                                                open={openDeSubDistrict}
                                                onClose={() => fnSetOpenDeAddress(txt.tambol, false)}
                                                getOptionLabel={(option) => option.subDistrict}
                                                value={deSubDistrict}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        placeholder="พิมพ์แขวง/ตำบล"
                                                        onInput={(e) => onInputChangeDeAddress(e, txt.tambol)}
                                                    />
                                                )}
                                                renderOption={fnRenderOption}
                                            />
                                        )}
                                    />

                                    <Controller
                                        name="deAmphoeId"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                freeSolo
                                                disableClearable
                                                onChange={fnOnChangeDeAddress}
                                                options={addressList}
                                                open={openDeAmphoe}
                                                onClose={() => fnSetOpenDeAddress(txt.amphoe, false)}
                                                getOptionLabel={(option) => option.amphoe}
                                                value={deAmphoe}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        placeholder="พิมพ์เขต/อำเภอ"
                                                        onInput={(e) => onInputChangeDeAddress(e, txt.amphoe)}
                                                    />
                                                )}
                                                renderOption={fnRenderOption}
                                            />
                                        )}
                                    />

                                </div>

                                <div className="">
                                    <InputLabel className="text-header1 text-left" htmlFor="ddlProvince">จังหวัด</InputLabel>
                                    <Controller
                                        name="deProvinceId"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                freeSolo
                                                disableClearable
                                                onChange={fnOnChangeDeAddress}
                                                options={addressList}
                                                open={openDeProvince}
                                                onClose={() => fnSetOpenDeAddress(txt.province, false)}
                                                getOptionLabel={(option) => option.province}
                                                value={deProvince}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        placeholder="พิมพ์จังหวัด"
                                                        onInput={(e) => onInputChangeDeAddress(e, txt.province)}
                                                    />
                                                )}
                                                renderOption={fnRenderOption}
                                            />
                                        )}
                                    />
                                </div>

                                <div className="mt-3">
                                    <InputLabel className="text-header1 text-left" htmlFor="txtZipCode">รหัสไปรษณีย์</InputLabel>
                                    <Controller
                                        name="deZipCode"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                freeSolo
                                                disableClearable
                                                onChange={fnOnChangeDeAddress}
                                                options={addressList}
                                                open={openDeZipCode}
                                                onClose={() => fnSetOpenDeAddress(txt.zipCode, false)}
                                                getOptionLabel={(option) => option.zipcode}
                                                value={deZipCode}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        placeholder="พิมพ์รหัสไปรษณีย์"
                                                        onInput={(e) => onInputChangeDeAddress(e, txt.zipCode)}
                                                    />
                                                )}
                                                renderOption={fnRenderOption}
                                            />
                                        )}
                                    />
                                </div>
                            </div>


                            <br></br>
                            <br></br>
                        </div>
                    </div>
                </Container>
                <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
                    <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <SecondaryButton variant="outlined" className="w-[40%]"
                            onClick={() => {
                                if (address) {
                                    navigate(-1)
                                } else {
                                    setOpenCancelPopup(true)
                                }
                            }}>
                            ยกเลิก
                        </SecondaryButton>
                        {address ? (
                            <PrimaryButton variant="contained" disabled={!isAddressCorrect || !isDetails} className="w-[40%]" onClick={() => setOpenConfirmPopup(true)}>
                                ยืนยัน
                            </PrimaryButton>
                        ) : (
                            <PrimaryButton variant="contained" disabled={!isAddressCorrect || !isDetails} className="w-[40%]" onClick={() => postUpdateMember()}>
                                บันทึก
                            </PrimaryButton>
                        )}

                    </Stack>
                </div>
            </form>
        </>
    );
}
